'use client';
import MiniCart from './mini-cart';
import useCart from '@/store/cart.store';
import { useTranslations } from 'next-intl';
import { calcCartTotalHandler } from '@/helpers/cart';
import { handlePriceByComma } from '@/helpers/common';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import CartHeaderIcon from '@/components/ui/icons/cart-header-icon';

const CartPopup = () => {
  const t = useTranslations('common');
  const cartItems = useCart((state) => state.cartItems);

  const total = calcCartTotalHandler(cartItems || []);

  return (
    <div className='group relative hidden cursor-pointer items-center gap-3.5 lg:flex'>
      <span className='relative flex size-10 items-center justify-center rounded-full bg-[#F6F6F7]'>
        <CartHeaderIcon />
        <span className='absolute end-0 top-0 z-10 flex size-3.5 items-center justify-center rounded-full bg-[#8B0000] text-[10px] font-bold text-white'>
          {cartItems?.length || 0}
        </span>
      </span>
      <div className='flex flex-col'>
        <span className='text-xs text-[#74787C]'>{t('My Cart')}</span>
        <span className='flex items-center gap-1 text-xs'>
          {handlePriceByComma(total || 0)} <CurrencyIcon className='size-2.5' />
        </span>
      </div>
      <MiniCart cartItems={cartItems} total={total} />
    </div>
  );
};

export default CartPopup;
